import { fetchContractors } from '@/services/contractorsService'

export default {
    async fetchContractors({ commit }, { limit, offset, query = '' }) {
        try {
            const response = await fetchContractors(limit, offset, query)
            const { contractors, total } = response.data

            commit('SET_CONTRACTORS', contractors || [])
            commit('SET_CONTRACTORS_TOTAL', total || 0)
        } catch (error) {
            console.error('Failed to execute fetchContractors:', error)
        }
    },
}
